import { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { SectionBlock } from '../../blocks/SectionBlock';
import { Spinner } from '../../components/Spinner';
import { Resource, ACTIONS } from '../../constants/constants';
import { CanRoute } from '../../contexts/AbilityContext/components/CanRoute';
import { AnalyticsProvider } from '../../contexts/AnalyticsContext/AnalyticsProvider';

import CheckInQualityTable from './components/CheckInQualityTable';
import { TeamWiseStats } from './components/TeamWiseStats';
import TopBar from './components/TopBar';
import { useGetCheckInsData } from './hooks/useGetCheckInsData';
import { TeamOption } from './types/checkInQuality';

function CheckInUsage(): JSX.Element {
  const [selectedTeam, setSelectedTeam] = useState<TeamOption | null>(null);
  const { teamWiseUserAnalyticData, isLoading, error } = useGetCheckInsData();
  if (isLoading || error)
    return (
      <div className="flex h-[80%] items-center justify-center w-full ">
        {error ? 'Oops! Error while fetching data.' : <Spinner />}
      </div>
    );
  return (
    <div className="flex flex-col items-start gap-2  max-w-screen-l h-full mx-auto mb-10">
      <TopBar
        title="Analytics - Check-In Usage"
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
      />
      <TeamWiseStats
        data={teamWiseUserAnalyticData}
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
      />
    </div>
  );
}

export function CheckInQuality(): JSX.Element {
  const [selectedTeam, setSelectedTeam] = useState<TeamOption | null>(null);
  return (
    <div className="flex flex-col items-start gap-2  max-w-screen-l h-full mx-auto mb-10">
      <TopBar
        title="Analytics - Check-In Quality"
        selectedTeam={selectedTeam}
        setSelectedTeam={setSelectedTeam}
        hideGoalHeader
      />
      <SectionBlock skipContentContainer className="w-full">
        <CheckInQualityTable selectedTeam={selectedTeam} />
      </SectionBlock>
    </div>
  );
}

export function AnalyticsPage(): JSX.Element {
  return (
    <AnalyticsProvider>
      <Routes>
        <Route path="/" element={<Navigate to="check-in-usage" replace />} />
        <Route
          path="check-in-usage"
          element={
            <CanRoute
              subject={Resource.CheckInUsage}
              action={ACTIONS.READ}
              element={<CheckInUsage />}
            />
          }
        />
        <Route
          path="check-in-quality"
          element={
            <CanRoute
              subject={Resource.CheckInQuality}
              action={ACTIONS.READ}
              element={<CheckInQuality />}
            />
          }
        />
      </Routes>
    </AnalyticsProvider>
  );
}
